var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiberyusCelikler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 88,
    viewBox: "0 0 110 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_688_2904)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8281 87.8055V81.1455H33.0933V83.3943H35.1858V81.1455H37.4726V87.8055H35.1858V85.2107H33.0933V87.8055H30.8281Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4863 84.4538C38.4863 83.3726 38.8099 82.5077 39.4787 81.8806C40.1259 81.2536 41.0319 80.9292 42.1537 80.9292C43.2755 80.9292 44.1816 81.2319 44.8288 81.8806C45.4759 82.4861 45.8211 83.351 45.8211 84.4538C45.8211 85.5566 45.4975 86.3999 44.8288 87.0486C44.1816 87.654 43.2755 88 42.1537 88C41.0319 88 40.1259 87.6973 39.4787 87.0486C38.8099 86.4215 38.4863 85.5566 38.4863 84.4538ZM40.7946 84.4538C40.7946 85.6863 41.2692 86.2918 42.1969 86.2918C43.1245 86.2918 43.0166 86.1404 43.2324 85.8377C43.4481 85.5349 43.556 85.0809 43.556 84.4322C43.556 83.7835 43.4481 83.351 43.2324 83.0267C43.0166 82.7456 42.6715 82.5726 42.1969 82.5726C41.2477 82.6158 40.7946 83.2213 40.7946 84.4538Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8789 87.8055V81.1455H49.1441V86.0107H52.2074V87.8055H46.8789Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1348 87.8054V81.1238H55.8745C56.4786 81.1238 56.91 81.1238 57.2336 81.1886C57.6651 81.2535 58.0318 81.3616 58.3122 81.513C59.3046 82.0536 59.7792 83.0266 59.7792 84.4754C59.7792 85.9241 59.1752 87.0269 57.9671 87.5242C57.5356 87.7189 56.6727 87.8054 55.4215 87.8054H53.1348ZM55.3999 86.1187H56.004C56.5649 86.1187 56.9747 85.989 57.1689 85.7728C57.3846 85.5349 57.4925 85.1025 57.4925 84.4754C57.4925 83.8483 57.3846 83.4591 57.1689 83.1996C56.9532 82.9617 56.5649 82.832 56.0255 82.832H55.3999V86.1187Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8789 87.8054V81.1238H63.1872V87.8054H60.8789ZM60.8789 80.5833V79.1561H63.1872V80.5833H60.8789Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5684 87.8054V81.1238H66.7256L68.7104 84.2159C68.8398 84.4105 68.9692 84.7349 69.1202 85.1889C69.0771 84.9727 69.0555 84.6484 69.0555 84.2808V81.1454H71.2128V87.827H69.0555L67.0708 84.7565C66.9414 84.5619 66.8119 84.2375 66.6609 83.7834C66.7041 83.9997 66.7256 84.324 66.7256 84.6916V87.8054H64.5684Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7924 87.8054L77.6845 87.2216C77.1668 87.7405 76.4333 87.9784 75.4841 87.9784C74.5349 87.9784 73.6719 87.6757 73.1111 87.027C72.5286 86.3999 72.2266 85.535 72.2266 84.4322C72.2266 83.3294 72.5502 82.4645 73.1973 81.8374C73.8445 81.2319 74.7506 80.9076 75.9155 80.9076C77.0805 80.9076 77.5766 81.1238 78.1375 81.5563C78.6984 81.9888 79.0436 82.5942 79.1515 83.3726H76.9942C76.8 82.8104 76.4333 82.551 75.8508 82.551C74.9447 82.551 74.4917 83.1997 74.4917 84.5187C74.4917 85.8377 74.9447 86.335 75.8724 86.335C76.8 86.335 76.4764 86.2485 76.7137 86.1188C76.951 85.9674 77.102 85.7728 77.1452 85.5133H76.1313V84.0862H79.2162V87.7405L77.7924 87.8054Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.853 67.4146H103.032C103.744 67.4146 104.262 67.3065 104.564 67.1335C104.887 66.9389 105.038 66.5497 105.038 66.0307C105.038 65.5118 104.866 65.0577 104.521 64.8631C104.218 64.6901 103.679 64.6252 102.903 64.6252H100.853V67.4146ZM96.1502 76.0207V60.9493H103.269C105.448 60.9493 107.023 61.2736 107.951 61.9223C108.965 62.5927 109.461 63.7387 109.461 65.2956C109.461 66.8524 108.662 68.3444 107.066 69.0364C107.886 69.231 108.49 69.577 108.878 70.0743C109.245 70.5932 109.461 71.3501 109.482 72.3664L109.569 74.4638C109.569 74.8314 109.612 75.0693 109.633 75.1774C109.698 75.3504 109.827 75.4368 110 75.4368V75.9991H105.189C104.995 75.2639 104.93 74.7449 104.93 74.4206V72.9286C104.93 72.1501 104.779 71.5879 104.477 71.2852C104.175 70.9608 103.658 70.8095 102.903 70.8095H100.875V75.9991H96.1502V76.0207ZM81.7396 76.0207V60.9493H93.6478V64.5604H86.5287V66.5713H92.5476V70.031H86.5287V72.3447H93.9498V76.0207H81.7396ZM68.4938 76.0207V60.9493H73.2614V72.0204H79.7549V76.0207H68.4938ZM52.3573 76.0207V60.9493H57.0818V65.9443L61.3532 60.9493H66.919L61.5905 66.5065L67.5878 76.0207H61.8925L58.2467 69.9878L57.0602 71.2203V76.0207H52.3573ZM44.5695 76.0207V60.9493H49.445V76.0207H44.5695ZM31.2591 76.0207V60.9493H36.0267V72.0204H42.5201V76.0207H31.2591ZM16.8484 76.0207V60.9493H28.735V64.5604H21.616V66.5713H27.6348V70.031H21.616V72.3447H29.0371V76.0207H16.8484ZM9.44891 76.3018L8.24083 78.9831L4.44401 78.9182L5.93254 76.3018C4.35772 76.0423 3.06335 75.372 2.04942 74.3341C0.668759 72.9069 0 70.9608 0 68.4958C0 66.0307 0.668758 64.1063 2.02785 62.6791C3.40851 61.252 5.2422 60.5385 7.57207 60.5385C9.90194 60.5385 11.412 61.079 12.6417 62.1386C13.8929 63.1765 14.5833 64.6901 14.7343 66.6362H10.1824C10.0314 65.101 9.16846 64.3225 7.65836 64.3225C6.14826 64.3225 4.85389 65.728 4.85389 68.4958C4.85389 71.2636 5.84624 72.6691 7.7878 72.6691C9.72936 72.6691 10.1608 71.8474 10.3118 70.1824H14.8421C14.6911 72.1717 14.0224 73.707 12.7711 74.8314C11.8866 75.6098 10.7864 76.1072 9.44891 76.3018Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70714 75.718L8.24018 78.9614L4.44336 78.8966L6.40649 75.4801L9.70714 75.718Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4458 57.1869H44.5703V59.8682H49.4458V57.1869Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2455 0.101685L71.3416 0.599019L70.5434 11.7134L60.4258 11.0647L61.2455 0.101685Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9922 35.3907C47.0493 36.8179 48.4299 38.2018 50.1342 39.4559C53.9094 42.2237 58.1161 43.6508 62.6249 43.6508C67.1336 43.6508 73.0446 41.229 73.929 40.7317C72.2679 40.3208 64.5017 38.7207 64.5017 38.7207C64.5017 38.7207 52.8308 43.9319 45.9922 35.3907Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2065 24.2332C38.2051 17.4867 43.5767 14.1567 48.6464 12.5566C54.6436 10.5457 60.08 11.1079 60.08 11.1079L61.0292 0.188152C61.0292 0.188152 41.1821 -2.70936 33.3943 14.2C27.4834 27.0442 32.6393 36.2989 35.5085 39.9749C32.7472 35.3475 32.6824 30.0714 35.2065 24.2332Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4228 24.3197C29.5119 37.7044 38.8529 44.8617 46.4034 49.0999C50.0061 51.1108 55.313 52.3217 60.6199 52.3217C65.9269 52.3217 68.0842 51.6946 71.1259 50.4837C71.6437 49.2296 73.5637 42.4832 73.9735 40.9912C72.8733 41.5966 68.3646 43.9103 62.6262 43.9103C56.8878 43.9103 53.8029 42.4832 49.9845 39.6505C44.3109 35.4772 42.0673 30.0498 43.6205 24.3629C45.3895 17.9624 51.7103 12.5566 58.6568 11.3241H58.2469C53.091 11.3241 40.6003 12.5999 35.4228 24.3197Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_688_2904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberyusCelikler);
export default __webpack_public_path__ + "static/media/liberyus-celikler.67b2c86a675d90ff5552a9766abf812e.svg";
export { ForwardRef as ReactComponent };